<template>
  <q-circular-progress
      indeterminate
      size="2em"
      :thickness=".3"
      color="secondary"
      track-color="accent"
  />
</template>

<script>
export default {}
</script>
